import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3zM3.7 15H10v4a3 3 0 0 0 3 3l1-6 2-2V3H6.3a2 2 0 0 0-1.97 1.67l-1.3 7A2 2 0 0 0 3.7 15" }, null, -1)
  ]))]))
}
export default { render: render }